import { combineReducers } from 'redux-immutable';
import { reducer as form } from 'redux-form/immutable';
import { sessionImmutableReducer as session } from 'redux-react-session';

import router from './routerReducer';
import bid from './bidReducer';
import agreement from './agreementReducer';
import cycle from './cycleReducer';
import student from './studentReducer';
import parent from './parentReducer';
import gradeInstance from './gradeInstanceReducer';
import report from './reportReducer';

const rootReducer = combineReducers({
  router,
  form,
  session,
  bid,
  agreement,
  cycle,
  student,
  parent,
  gradeInstance,
  report
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js